module.exports = __webpack_public_path__ + "img/design.3bf5930b.jpg";